<template>
    <auth-layout :snackbar="snackbar" @snackbar:close="snackbar = null">
        <div class="auth-reset-password">
            <typo name="title-18-bold"> Réinitialisation du mot de passe </typo>
            <sep name="M"></sep>
            <v-form class="form" ref="form" v-model="valid">
                <password-text-field
                    v-model="values.password"
                    placeholder="Nouveau mot de passe"
                    required
                    :rules="[required, password]"
                />
                <password-text-field
                    v-model="values.passwordConfirmation"
                    placeholder="Répéter le mot de passe"
                    required
                    :rules="[required, equals(values.password)]"
                />
                <div class="buttons">
                    <action @click="validate" name="main">Valider</action>
                </div>
                <typo class="legend" name="body-12-normal">
                    <i>
                        Le mot de passe doit comporter au moins 8 caractères et doit contenir un caractère spécial, un
                        nombre et une majuscule
                    </i>
                </typo>
            </v-form>
        </div>
    </auth-layout>
</template>

<script>
import Vue from "vue";
import AuthLayout from "./AuthLayout.vue";
import PasswordTextField from "src/components/common/form/PasswordTextField.vue";
import { Services } from "src/services/Services";
import { initialAuthFormData } from "src/utils/auth-form";

export default Vue.extend({
    components: {
        PasswordTextField,
        AuthLayout,
    },
    data() {
        return {
            ...initialAuthFormData,
            values: {
                password: "",
                passwordConfirmation: "",
                token: this.$route.query.token,
                userId: this.$route.query.userId,
            },
        };
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
    },
    methods: {
        async validate() {
            if (this.$refs.form.validate()) {
                try {
                    this.isSubmitting = true;
                    await Services.api.auth.resetPassword(this.values);
                    this.snackbar = {
                        text: `Mot de passe modifié. `,
                        color: "success",
                    };
                    this.$router.push({ name: "login" });
                } catch (e) {
                    this.snackbar = {
                        text: this.dico.errors[e.payload.code || "auth_general"],
                        color: "error",
                    };
                } finally {
                    this.isSubmitting = false;
                }
            }
        },
    },
});
</script>

<style lang="sass" scoped>

.buttons
    display: flex
    margin-top: $grid-gutter

.form
    width: 400px
</style>
